module.exports = __webpack_public_path__ + "static/ankita-masand-cf66a910edb1531421e1e6b896f2fec3.png";